<template>
  <div class="lcu-footerContainer">
    <div class="lcu-footer">
      <div>
        <img
          class="lcu-footer-logo"
          src="/assets/lcu-logo-gold-wide.svg"
          alt="LCU Footer Logo" />
      </div>
      <div class="lcu-footer-links">
        <router-link
          class="lcu-footer-link"
          to="/politica-de-privacidad">
           Política de Privacidad
        </router-link>
        <router-link
          class="lcu-footer-link"
          to="/terminos-de-uso">
          Términos de Uso
        </router-link>
        <router-link
          class="lcu-footer-link"
          to="/declaracion-de-accesibilidad">
          Declaración De Accesibilidad
        </router-link>
      </div>
      Copyright {{ currentYear }} Legacy Christian University.
      Todos los derechos reservados.
    </div>
  </div>
</template>

<script>

export default {
  name: 'global-footer',
  data() {
    return {
      currentYear: null,
    };
  },
  created() {
    this.currentYear = new Date().getFullYear();
  },
};
</script>

<style scoped lang="scss">
.lcu-footerContainer {
  background-color: $legacy-primary;

  @media print {
    display: none;
  }
}

.lcu-footer {
  align-items: center;
  color: rgba($white, .6);
  display: flex;
  flex-direction: column;
  font-size: 13px;
  justify-content: center;
  margin: 0 auto;
  padding: 35px 0;
  text-align: center;
  width: 90%;
  max-width: $section-max-width;

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 65px;
  }
}

.lcu-footer-logo {
  margin-bottom: 25px;
  width: 120px;
}

.lcu-footer-links {
  margin-bottom: 25px;
}

.lcu-footer-link {
  display: inline-block;
  color: rgba($white, .6);
  margin-right: 25px;
  text-decoration: underline;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    color: $white;
  }
}
</style>
